import { GraphQLClient } from 'graphql-request'
import { GraphqlClientBuilder } from './interface'

/**
 * シンプルなGraphqlClient生成用。
 * backend-shopへの接続の用途で利用するために作成。
 * NOTE: ざっくり実装
 *
 * FIXME: Sentry通知等のエラーハンドリング未定義。
 * client.request時にtry-catchでハンドリングしろとのことなので、やりにくそう。 https://github.com/prisma-labs/graphql-request#error-handling
 *
 */

export const createGraphqlClient: GraphqlClientBuilder = ({ backendUri }) => {
  return new GraphQLClient(backendUri, {})
}
